import { Component, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CapteurExportService } from '../../../services/capteurs-export.service';

@Component({
  selector: 'app-export-excel-capteurs',
  imports: [CommonModule],
  templateUrl: './export-excel-capteurs.component.html',
  styleUrl: './export-excel-capteurs.component.scss'
})
export class ExportExcelCapteurs {
  protected exporting = false;
  protected error = '';
  protected success = '';

  constructor(
    private readonly capteurExportService: CapteurExportService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  protected async exportPositions(): Promise<void> {
    this.exporting = true;
    this.error = '';
    this.success = '';
    this.cdr.markForCheck();

    try {
      await this.capteurExportService.exportToExcel();
      this.success = 'Export Excel réussi ! Le fichier a été téléchargé.';
      this.exporting = false;
      this.cdr.markForCheck();
    } catch (err: unknown) {
      const errorMessage = err instanceof Error ? err.message : 'Erreur inconnue';
      this.error = `Erreur lors de l'export : ${errorMessage}`;
      this.exporting = false;
      this.cdr.markForCheck();
    }
  }
}
